import { sub } from 'date-fns'
import * as Yup from 'yup'

import { passwordYupShape } from 'common/password-validation'

export const minGradYear = new Date().getFullYear() - 100
export const maxGradYear = new Date().getFullYear() + 10

// Standard linked student validation. Location is not collected
export const studentYupValidation = Yup.object().shape({
  firstName: Yup.string().required('First Name is Required.'),
  lastName: Yup.string().required('Last Name is Required.'),
  gradYear: Yup.number()
    .integer(`Please enter a proper year between ${minGradYear} and ${maxGradYear}.`)
    .moreThan(minGradYear - 1, `Please enter a proper year after ${minGradYear}.`)
    .lessThan(maxGradYear + 1, `Please enter a proper year before ${maxGradYear}.`)
    .required(`Please enter a proper year between ${minGradYear} and ${maxGradYear}.`),
  birthdate: Yup.date()
    .typeError('Must be formatted to mm/dd/yyyy')
    .min(sub(new Date(), { years: 100 }), 'Please enter a valid age.')
    .max(sub(new Date(), { years: 13 }), 'You must be at least 13 years of age or older.')
    .required('Birthdate is Required.'),
  password: Yup.object().shape(passwordYupShape()),
  confirmTOS: Yup.boolean().required().oneOf([true]),
})

// Validation for off the street students (Other HS) and grads from the USA
// City and State are required
export const otsStudentYupValidation = Yup.object().shape({
  firstName: Yup.string().required('First Name is Required.'),
  lastName: Yup.string().required('Last Name is Required.'),
  gradYear: Yup.number()
    .integer(`Please enter a proper year between ${minGradYear} and ${maxGradYear}.`)
    .moreThan(minGradYear - 1, `Please enter a proper year after ${minGradYear}.`)
    .lessThan(maxGradYear + 1, `Please enter a proper year before ${maxGradYear}.`)
    .required(`Please enter a proper year between ${minGradYear} and ${maxGradYear}.`),
  birthdate: Yup.date()
    .typeError('Must be formatted to mm/dd/yyyy')
    .min(sub(new Date(), { years: 100 }), 'Please enter a valid age.')
    .max(sub(new Date(), { years: 13 }), 'You must be at least 13 years of age or older.')
    .required('Birthdate is Required.'),
  password: Yup.object().shape(passwordYupShape()),
  confirmTOS: Yup.boolean().required().oneOf([true]),
  city: Yup.string().required('City is Required.'),
  stateOrProvince: Yup.string().required('State/Province is Required.'),
  country: Yup.string().required('Country is Required.'),
})

// Validation for international OTS students (Other HS) and grads
// City and State are optional
export const internationalStudentYupValidation = Yup.object().shape({
  firstName: Yup.string().required('First Name is Required.'),
  lastName: Yup.string().required('Last Name is Required.'),
  gradYear: Yup.number()
    .integer(`Please enter a proper year between ${minGradYear} and ${maxGradYear}.`)
    .moreThan(minGradYear - 1, `Please enter a proper year after ${minGradYear}.`)
    .lessThan(maxGradYear + 1, `Please enter a proper year before ${maxGradYear}.`)
    .required(`Please enter a proper year between ${minGradYear} and ${maxGradYear}.`),
  birthdate: Yup.date()
    .typeError('Must be formatted to mm/dd/yyyy')
    .min(sub(new Date(), { years: 100 }), 'Please enter a valid age.')
    .max(sub(new Date(), { years: 13 }), 'You must be at least 13 years of age or older.')
    .required('Birthdate is Required.'),
  password: Yup.object().shape(passwordYupShape()),
  confirmTOS: Yup.boolean().required().oneOf([true]),
  country: Yup.string().required('Country is Required.'),
  city: Yup.string(),
  stateOrProvince: Yup.string(),
})

export const isValidDate = (date: string) => {
  return date && date !== '0001-01-01'
}
